
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.5 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(-1.25)"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h20v20H0z"}})])]),_c('g',{attrs:{"data-name":"Grupo de máscara 1699"}},[_c('g',{attrs:{"data-name":"streamline-icon-professions-man-construction-1 20x20"}},[_c('g',{attrs:{"data-name":"Grupo 4180","clip-path":"url(#a)"}},[_c('g',{attrs:{"data-name":"Grupo 4179"}},[_c('path',{attrs:{"data-name":"Elipse 119","d":"M8.75 0a5 5 0 11-5 5 5 5 0 015-5zm0 8.75A3.75 3.75 0 105 5a3.75 3.75 0 003.75 3.75z"}}),_c('path',{attrs:{"data-name":"Caminho 3261","d":"M16.87 20a.62.62 0 01-.62-.62 7.5 7.5 0 00-15 0 .63.63 0 01-1.25 0 8.75 8.75 0 1117.5 0 .63.63 0 01-.63.62z"}}),_c('path',{attrs:{"data-name":"Caminho 3262","d":"M8.75 16.25A3.75 3.75 0 015 12.5v-.62a.63.63 0 111.25 0v.62a2.5 2.5 0 005 0v-.62a.63.63 0 111.25 0v.62a3.75 3.75 0 01-3.75 3.75z"}}),_c('path',{attrs:{"data-name":"Linha 168","d":"M3.75 20a.62.62 0 01-.62-.62V13a.62.62 0 111.24 0v6.41a.62.62 0 01-.62.59z"}}),_c('path',{attrs:{"data-name":"Linha 169","d":"M13.75 20a.62.62 0 01-.62-.62V13a.62.62 0 111.24 0v6.41a.62.62 0 01-.62.59z"}}),_c('path',{attrs:{"data-name":"Linha 170","d":"M7.29 6a.62.62 0 01-.62-.62V.88a.63.63 0 111.25 0v4.54a.63.63 0 01-.63.58z"}}),_c('path',{attrs:{"data-name":"Linha 171","d":"M10.21 6a.63.63 0 01-.63-.62V.88a.63.63 0 111.25 0v4.54a.62.62 0 01-.62.58z"}})]),_c('path',{attrs:{"data-name":"Linha 172","d":"M14.37 6H3.13a.63.63 0 110-1.25h11.24a.63.63 0 110 1.25z"}})])])])])
          )
        }
      }
    